import { render, staticRenderFns } from "./TipoServNvo.vue?vue&type=template&id=2e38f878&"
import script from "./TipoServNvo.vue?vue&type=script&lang=js&"
export * from "./TipoServNvo.vue?vue&type=script&lang=js&"
import style0 from "./TipoServNvo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports